import { render, staticRenderFns } from "./BusinessTaxReturns.vue?vue&type=template&id=3b5aa5a6&scoped=true&"
import script from "./BusinessTaxReturns.vue?vue&type=script&lang=ts&"
export * from "./BusinessTaxReturns.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTaxReturns.vue?vue&type=style&index=0&id=3b5aa5a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5aa5a6",
  null
  
)

export default component.exports